<template>
  <div>
    <ul class="flex flex-col">
      <li
        v-for="(benefit, index) in displayedBenefits"
        :key="index"
        class="flex flex-row items-center gap-2 text-base"
      >
        <IconUiCheckmark class="size-3" />
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="$t(benefit)" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const { isMobile } = useDeviceType()

const benefits = [
  'pdp.benefits.fast_delivery',
  'pdp.benefits.free_returns',
  'pdp.benefits.secure_payment',
]

const mobileBenefits = [
  'pdp.mobile_benefits.top_quality_materials',
  'pdp.mobile_benefits.exclusive_items',
  'pdp.mobile_benefits.timeless_elegance',
]

const displayedBenefits = computed(() =>
  isMobile.value ? mobileBenefits : benefits,
)
</script>
